<template>
  <div>
    <div class="page-header">
      <div class="page-header-index-wide">
        <a-breadcrumb class="breadcrumb">
          <a-breadcrumb-item>
            <span>用户管理</span>
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            <span>管理员</span>
          </a-breadcrumb-item>
        </a-breadcrumb>
        <div class="detail">
          <div class="main" >
            <div class="row">
              <h1 class="title">管理员</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="m-y-10">
      <ak-model-filter-card model="administrator" @search="search" @reset="reset" />
    </div>
    <ak-model-card ref="table" model="administrator" :page.sync="page" :filters="filters"/>
  </div>
</template>
<script>
export default {
  data () {
    return {
      filters: {},
      page: 1
    }
  },
  methods: {
    search (filters) {
      // filters是组件自动生成的where搜索参数
      this.page = 1
      this.filters = filters // 修改modelTable的查询条件会自动触发刷新
    },
    reset () {
      this.page = 1
      this.filters = {}
    }
  }
}
</script>
<style lang="scss" scoped>
  .page-header {
    background: #fff;
    padding: 16px 32px 0;
    border-bottom: 1px solid #e8e8e8;
    margin: -24px -24px 24px -24px;
    .breadcrumb {
      margin-bottom: 16px;
    }
    .detail {
      display: flex;
      /*margin-bottom: 16px;*/
      .avatar {
        flex: 0 1 72px;
        margin: 0 24px 8px 0;
        & > span {
          border-radius: 72px;
          display: block;
          width: 72px;
          height: 72px;
        }
      }
      .main {
        width: 100%;
        flex: 0 1 auto;
        .row {
          display: flex;
          width: 100%;
          .avatar {
            margin-bottom: 16px;
          }
        }
        .title {
          font-size: 20px;
          font-weight: 500;
          font-size: 20px;
          line-height: 28px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.85);
          margin-bottom: 16px;
          flex: auto;
        }
        .logo {
          width: 28px;
          height: 28px;
          border-radius: 4px;
          margin-right: 16px;
        }
        .content,
        .headerContent {
          flex: auto;
          color: rgba(0, 0, 0, 0.45);
          line-height: 22px;
          .link {
            margin-top: 16px;
            line-height: 24px;
            a {
              font-size: 14px;
              margin-right: 32px;
            }
          }
        }
        .extra {
          flex: 0 1 auto;
          margin-left: 88px;
          min-width: 242px;
          text-align: right;
        }
        .action {
          margin-left: 56px;
          min-width: 266px;
          flex: 0 1 auto;
          text-align: right;
          &:empty {
            display: none;
          }
        }
      }
    }
  }
  .mobile .page-header {
    .main {
      .row {
        flex-wrap: wrap;
        .avatar {
          flex: 0 1 25%;
          margin: 0 2% 8px 0;
        }
        .content,
        .headerContent {
          flex: 0 1 70%;
          .link {
            margin-top: 16px;
            line-height: 24px;
            a {
              font-size: 14px;
              margin-right: 10px;
            }
          }
        }
        .extra {
          flex: 1 1 auto;
          margin-left: 0;
          min-width: 0;
          text-align: right;
        }
        .action {
          margin-left: unset;
          min-width: 266px;
          flex: 0 1 auto;
          text-align: left;
          margin-bottom: 12px;
          &:empty {
            display: none;
          }
        }
      }
    }
  }
</style>
